import makeStyles from "@mui/styles/makeStyles";
import { Bold, Regular, SemiBold } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    listRoot: {
        padding: "12px 0px",
        backgroundColor: "white",
        borderRadius: "4px"
    },
    lable: {
        fontSize:"0.875rem",
        color: "#4E5A6B",
        padding: "12px",
        cursor: "pointer"
    },
    labelSelected: {
        fontSize:"0.875rem",
        color: "white",
        fontFamily: Bold,
        borderRadius: "4px",
        padding: "12px",
        cursor: "pointer",
        backgroundColor: "#5078E1"
    },
    lableContact: {
        fontSize:"0.75rem",
        color: "#1C1C1C",
        padding: "4px",
        cursor: "pointer",
        fontFamily: SemiBold,
        alignItems: "center"

    },
    labelSelectedContact: {
        fontSize:"0.75rem",
        color: "white",
        fontFamily: Bold,
        borderRadius: "4px",
        padding: "4px",
        cursor: "pointer",
        backgroundColor: "#5078E1",
        alignItems: "center"

    },
    subTitle: {
        fontSize:"0.875rem",
        color: "#98A0AC",
        fontFamily: Regular,
    },
    title: {
        fontSize:"1rem",
        color: "#091B29",
        fontFamily: Bold,
    },
    root: {
        padding: "12px",
        backgroundColor: "white",
        borderBottom: "1px solid #E4E8EE"
    },
    btn: {
        boxShadow: "none"
    },
    paymetRoot: {
        backgroundColor: "white",
        padding: "12px",
        height: "80px",
        display: "flex",
        width: "180px",
        alignItems: "center",
        borderRadius: "4px",
        border: "1px solid #E4E8EE",
        margin: "12px",
        position: "relative",
        cursor: "pointer"
    },
    checked: {
        color: "#5078E1",
        position: "absolute",
        top: 4,
        right: 4,
        fontSize:"0.9375rem"
    },
    stepTitle: {
        fontSize:"0.75rem",
        color: "#4E5A6B",
        fontFamily: Bold,
    },
    step: {
        backgroundColor: "#4E5A6B",
        color: "white",
        height: "20px",
        width: "20px",
        fontSize:"0.75rem",
        fontFamily: Bold,
    },
    jobText: {
        fontFamily: SemiBold,
        fontSize:"0.75rem",
        color: "#7C8594",
        alignItems: "center"


    },
    jobTextSelected: {
        fontFamily: SemiBold,
        fontSize:"0.75rem",
        color: "white",
        alignItems: "center"

    },
    heading: {
        fontFamily: Bold,
        fontSize:"1rem",
        color: theme.typography.color.primary,
        borderBottom: `1px solid ${theme.palette.border.secondary}`,
        padding: "12px"
    },
    noData: {
        fontFamily: Bold,
        fontSize:"1rem",
        color: theme.typography.color.primary,
        padding: "12px",
        textAlign: "center",
        marginTop: "50%"
    }
}));